import JSZip from 'jszip'

const parseBinary = async (file) => {
    return new Promise((resolve, reject) => {
        let content = '';
        const reader = new FileReader();
        reader.onloadend = function(e) {
            content = e.target.result;
            resolve(content);
        };
        reader.onerror = function(e) {
            reject(e);
        };
        reader.readAsText(file);
    });
}

export function parseModelType(metadata){
    switch(metadata.modelName){
        case "tm-my-image-model":
            return 'image'
        case "my-pose-model":
            return 'pose'
        case "TMv2":
            return 'speech'
        case "object-detection":
            return 'detection'
        case "my-face-model":
            return 'face'
    }
    switch(metadata.packageName){
        case "@teachablemachine/image":
            return 'image'
        case "@teachablemachine/pose":
            return 'pose'
    }
    if(metadata.tfjsSpeechCommandsVersion){
        return 'speech'
    }
}
/* 
console.log(await parseModelUrl('https://itrain.eduairsz.xyz/models/QSdo0fYvO')) */

export async function parseModelUrl(url){
    async function urlAnalyzer(url) {
        const response = await fetch(url);
        const metadata = await response.json();
        return {type: parseModelType(metadata), labels: metadata.labels || metadata.wordLabels}
    }

    async function urlHandler(url, baseUrl) {
        let tmURL = ""
        let path = ""

        switch (baseUrl) {
            case "https://teachablemachine.withgoogle.com":
                path = new URL(url).pathname.split("/").filter(Boolean).pop();
                tmURL = `https://storage.googleapis.com/tm-model/${path}`
                break;
            case "https://itrain.eduairsz.xyz":
                path = new URL(url).pathname.split("/").filter(Boolean).pop();
                tmURL = `https://storage.eduairsz.xyz/models/${path}`
                break;
            default:
                tmURL = url
                break;
        }
        
        let modelJson, metadataJson, canvasJson
        let modelFile, metadataFile, weightsArray = [], weightsFiles = []

        const modelUrl = `${tmURL}/model.json`;
        const modelRequest = await fetch(modelUrl)
        if (modelRequest.ok) {
            modelJson = await modelRequest.json()
            const modelBlob = new Blob([JSON.stringify(modelJson)], { type: "application/json" });
            modelFile = new File([modelBlob], 'model.json', { type: 'text/plain' })
        }

        const metadataUrl = `${tmURL}/metadata.json`;
        const metadataRequest = await fetch(metadataUrl)
        if (metadataRequest.ok) {
            metadataJson = await metadataRequest.json()
            const metadataBlob = new Blob([JSON.stringify(metadataJson)], { type: "application/json" });
            metadataFile = new File([metadataBlob], 'metadata.json', { type: 'text/plain' })
        }

        const weights = modelJson.weightsManifest[0]
        if (weights) {
            for (let path of weights.paths) {
                const pathSplit = path.split('/')
                const filePath = pathSplit[pathSplit.length - 1]
                const weightsUrl = `${tmURL}/${filePath}`;
                const weightsRequest = await fetch(weightsUrl)
                if (weightsRequest.ok){
                    const weightsBlob = await weightsRequest.blob()
                    const weightsFile = new File([weightsBlob], filePath, { type: 'application/octet-stream' })
                    weightsFiles.push(weightsFile)
                    weightsArray.push(await parseBinary(weightsFile))
                }
            }
        }

        const {type, labels} = await urlAnalyzer(metadataUrl)

        const canvasUrl = `${tmURL}/canvas`;
        try {
            const response = await fetch(canvasUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            canvasJson = await response.json();
        } catch (error) {
            // canvasJson = null
        }

        return {
            type: type,
            labels: labels,

            model: modelJson,
            metadata: metadataJson,
            weights: weightsFiles,
            canvas: canvasJson,

            modelFile: modelFile,
            metadataFile: metadataFile,
            weightsFiles: weightsFiles,
        }
    }

    try {
        const pathArray = url.split( '/' );
        const protocol = pathArray[0];
        const host = pathArray[2];
        const baseUrl = protocol + '//' + host;
        const parsedUrl = await urlHandler(url, baseUrl)
        return parsedUrl
    } catch (e) {
        throw ('Invalid Link')
    }
}

export async function parseModelZip(zip){
    const parse = (file) => {
        return new Promise((resolve, reject) => {
            let content = '';
            const reader = new FileReader();
            reader.onloadend = function(e) {
                content = e.target.result;
                /* const result = content.split(/\r\n|\n/); */
                resolve(content);
            };
            reader.onerror = function(e) {
                reject(e);
            };
            reader.readAsText(file);
        });
    }

    try {
        const jsZip = new JSZip();
        const unzip = await jsZip.loadAsync(zip);

        const weightsArray = [], weightsFiles = []

        console.log(unzip.files)

        const modelBlob = await unzip.files['model.json'].async("blob");
        const modelFile = new File([modelBlob], 'model.json');
        const modelJson = JSON.parse(await parse(modelFile))

        const metadataBlob = await unzip.files['metadata.json'].async("blob");
        const metadataFile = new File([metadataBlob], 'metadata.json');
        const metadataJson = JSON.parse(await parse(metadataFile))

        const type = parseModelType(metadataJson);

        const weights = modelJson.weightsManifest[0]
        if (weights) {
            for (let path of weights.paths) {
                const pathSplit = path.split('/')
                const filePath = pathSplit[pathSplit.length - 1]
                const fileBlob = await unzip.files[filePath].async("blob");
                if (fileBlob){
                    const weightsFile = new File([fileBlob], filePath)
                    weightsFiles.push(weightsFile)
                    weightsArray.push(await parseBinary(weightsFile))
                }
            }
        }


        let canvasJson
        if (unzip.files['canvas']) {
            const canvasFile = unzip.files['canvas']
            const canvsBlob = await canvasFile.async("blob")
            canvasJson = JSON.parse(await parse(canvsBlob))
        }

        return {
            type, 
            labels: metadataJson.labels || metadataJson.wordLabels,

            model: modelJson, 
            metadata: metadataJson, 
            weights: weightsArray, 
            canvas: canvasJson,

            modelFile: modelFile, 
            metadataFile: metadataFile, 
            weightsFiles: weightsFiles
        }
    } catch (error) {
        console.log(error)
        throw('Invalid Model')
    }
}

function toMimeType (fileExtension) {
    switch (fileExtension) {
        case '.png':
            return 'image/png'
        case '.bmp':
            return 'image/bmp'
        case '.jpg':
        case '.jpeg':
            return 'image/jpeg'
        case '.webm':
            return 'video/webm'
        case '.json':
            return 'application/json'
        default:
            return null
    }
}

export function imageFileToDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = function(){
                const width = img.width;
                const height = img.height;
                const size = Math.min(width, height); // Get the smaller dimension
                const x = (width - size) / 2; // Calculate the starting X position for cropping
                const y = (height - size) / 2; // Calculate the starting Y position for cropping

                // Create a canvas element
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");
                canvas.width = 224;
                canvas.height = 224;
                ctx.drawImage(img, x, y, size, size, 0, 0, 224, 224);

                // Get the cropped image as a base64 encoded string
                var croppedImage = canvas.toDataURL("image/jpeg");
                resolve(croppedImage);
            }

        };

        reader.onerror = () => {
            reject(reader.error);
        };

        reader.readAsDataURL(file);
    });
}

export function fileToDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export async function unzip(file){
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function(e) {
            const result = []
            const zipData = e.target.result;
            JSZip.loadAsync(zipData).then(async function(zip) {
                const files = Object.entries(zip.files);
                for (let i = 0; i < files.length; i++) {
                    const file = files[i][1]
                    const fileName = file.name
                    const fileExtension = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
                    const fileData = await file.async("blob");
                    const mimeType = toMimeType(fileExtension);
                    if (mimeType) {
                        const decompressedFile = new File([fileData], fileName, {type: mimeType});
                        result.push(decompressedFile)
                    }
                }
                /* await zip.forEach(async function(relativePath, zipEntry) {
                    if (!zipEntry.dir) {
                        const fileName = zipEntry.name
                        const fileExtension = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
                        const fileData = await zipEntry.async("blob");
                        console.log(fileData)
                        const decompressedFile = new File([fileData], fileName, {type: toMimeType(fileExtension)});
                        result.push(decompressedFile)
                    }
                }); */
                resolve(result)
            });
        };

        reader.onerror = function(e){
            reject(e)
        }
        
        reader.readAsArrayBuffer(file);
    })
}

export async function processFileInput(files){
    const result = []
    for( let i = 0; i < files.length; i++ ){
        const file = files[i];
        if(file.type == "application/zip" || file.type == "application/x-zip-compressed") {
            result.push(...(await unzip(file)))
        } else {
            result.push(file)
        }
    }
    return result
}

export function downloadFile(name, blob){
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
    URL.revokeObjectURL(link.href)
}

export function watchObjProp(obj, prop, callback) {
    let value = obj[prop];
    
    Object.defineProperty(obj, prop, {
        get() {
            return value;
        },
        set(newValue) {
            const oldVlaue = value;
            value = newValue;
            callback(newValue, oldVlaue);
        },
    });
}

